<template>
  <div id="search-result" class="dropdown-menu pre-scrollable" v-if="results.length > 0" :class="{ show: results }">
    <span 
      v-for="(result, index) in resultsHighlighted"
      :key="index"
      @click="clearSearch"
    >
      <h6 class="dropdown-header">{{ result.category }}</h6>
      <router-link :to=" {name: result.route }" class="dropdown-item">
        <span v-html="result.title"></span>: <span v-html="result.match"></span>
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: "SearchResult",
  props: {
    results: Array,
    currentSearch: String
  },
  methods: {
    clearSearch: function () {
      this.$emit('clear-search')
    }
  },
  computed: {
    resultsHighlighted: function () {
      return this.results.map((result) => {
        const regEx = new RegExp(this.currentSearch, 'ig')
        return {
          ...result,
          title: result.title.replace(regEx, str => `<mark>${str}</mark>`),
          match: result.match.replace(regEx, str => `<mark>${str}</mark>`)
        }
      })
    }
  }
};
</script>